module.exports = __webpack_public_path__ + "static/media/d2b_Dr. Brian-Su@3x.de76d46a.png";